//Models
PJQ.models.dailyReports.Note = PJQ.models.BaseModel.extend({
	idAttribute: 'noteId',
	notifyName: 'Note',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'notes',
				value: this.id
			}
		]);
	},
	parse: function (model) {
		model = model ? model : {};

		this.attachments = new PJQ.collections.dailyReports.NoteAttachments(model.attachments);
		this.attachments.on('update', _.bind(function () {
			this.isDirty = true;
		}, this));

		return model;
	},
	getCategoryName: function () {
		switch (this.get('category')) {
			case 0:
				return 'General Notes';
			case 1:
				return 'Safety Observations';
			case 2:
				return 'Quality Control Observations';
			case 3:
				return 'Materials';
			case 4:
				return 'Cost Impact';
			default:
				return '';
		}
	},
	beforeSave: function () {
		this.set('attachments', this.attachments.getChangedModels());
	},
	restoreDefaultTheme: function () {

	}
});

PJQ.models.dailyReports.NoteAttachment = PJQ.models.files.File.extend({
	idAttribute: 'noteAttachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'notes',
				value: this.get('noteId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

//Collections
PJQ.collections.dailyReports.Notes = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.Note
});

PJQ.collections.dailyReports.NoteAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.NoteAttachment
});